<template>
  <div id="about">
    <div class="firstPart">
      <div class="banner">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide>
            <el-image :src="banner1"></el-image>
            <div class="slideInfo wow fadeInUp">
              <div class="slideTitle">关于技术</div>
              <div class="aboutTxt">
                致力于将最成熟的先进技术灵活应用于实际场景，更准确、深入地洞察和理解用户痛点，并有效地转化为技术方案，落地产品。
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <el-image :src="banner2"></el-image>
            <div class="slideInfo wow fadeInUp">
              <div class="slideTitle">关于团队</div>
              <div class="aboutTxt">
                专业骨干具有消防行业十年以上从业经验，研发骨干具有物联网行业十年以上研发经验，对行业理解深刻，能为用户提供最具有应用价值的解决方案。
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <el-image :src="banner3"></el-image>
            <div class="slideInfo wow fadeInUp">
              <div class="slideTitle">关于应用</div>
              <div class="aboutTxt">
                产品应用于多个铁路站点、站段及五小场所，应用场景丰富，解决方案灵活。能够高效整合多方资源，为客户提供全面周到的服务。
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <div class="secondPart" style="display:none">
      <el-row :gutter="30" class="elRow">
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" align="center">
          <div class="aboutItem wow animate__zoomIn">
            <img src="../../assets/img/about/jishu.svg" alt="" class="bg1" />
            <div class="boxName">技术</div>
            <div class="boxNameEN">technology</div>
            <div class="boxDesc">
              致力于将最成熟的先进技术灵活应用于实际场景，更准确、深入地洞察和理解用户痛点，并有效地转化为技术方案，落地产品。
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" align="center">
          <div class="aboutItem wow animate__zoomIn">
            <img src="../../assets/img/about/tuandui .svg" alt="" class="bg2" />
            <div class="boxName">团队</div>
            <div class="boxNameEN">technology</div>
            <div class="boxDesc">
              专业骨干具有消防行业十年以上从业经验，研发骨干具有物联网行业十年以上研发经验，对行业理解深刻，能为用户提供最具有应用价值的解决方案。
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" align="center">
          <div class="aboutItem wow animate__zoomIn">
            <img src="../../assets/img/about/yingyong.svg" alt="" class="bg3" />
            <div class="boxName">应用</div>
            <div class="boxNameEN">technology</div>
            <div class="boxDesc">
              产品应用于多个铁路站点、站段及五小场所，应用场景丰富，解决方案灵活。能够高效整合多方资源，为客户提供全面周到的服务。
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="thirdPart">
      <el-row :gutter="50" class="middleRow">
        <el-col :xs="24" class="hidden-md-and-up" align="center">
          <img src="../../assets/img/about/us.png" alt="11" />
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14" align="left">
          <div class="itemTech wow fadeInUp">
            <h2 class="title2">关于我们</h2>
            <div class="content">
              南京铁辰安全技术有限公司作为<span
                style="color: #48bcbc; cursor: pointer"
                @click="gojiashi()"
                >江苏佳实</span
              >控股子公司，在总公司消防工程、维保、智能化业务基础上，主攻IT、物联网、大数据、AI方向，拓展智慧消防、安防领域。自主研发了智慧消防、智慧安防、智慧用电、智能烟感、视频RTC、AI视频识别等多个产品，广泛应用于多家单位，多次获得铁路局科技进步等奖项。
            </div>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="10"
          :xl="10"
          align="center"
          class="hidden-md-and-down"
        >
          <img src="../../assets/img/about/us.png" alt="22" />
        </el-col>
      </el-row>
    </div>
    <div class="fourthPart">
      <el-row :gutter="50" class="middleRow">
        <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14" align="left">
          <Map class="wow animate__zoomIn" />
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10" align="left">
          <div class="itemTech wow fadeInUp">
            <h2 class="title2" style="margin-bottom:2rem">成功案例</h2>
          </div>
          <div class="cateDesc">
            铁辰科技着力于铁路消防市场，业务范围覆盖江浙沪皖大量铁路单位；同时积极探索九小场所智慧消防业务，先后与诸多客户达成合作
          </div>
          <div class="logoBox">
            <div class="logos wow animate__zoomIn" v-for="(item,index) in patener" :key="index">
                <img :src="item.src" alt="">
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="lastPart">
      <div class="topPart">
        <h2 class="title">企业资质</h2>
      </div>
      <div class="certificateRow wow fadeInUp">
        <img src="../../assets/img/about/zizhi/yyzz.png" alt="" class="yyzz"/>
        <img src="../../assets/img/about/zizhi/15.png" alt="" class="RowImg" />
        <img src="../../assets/img/about/zizhi/16.png" alt="" class="RowImg" />
        <img src="../../assets/img/about/zizhi/55.png" alt="" class="RowImg lastImg" />
        <img src="../../assets/img/about/zizhi/22.jpg" alt="" class="RowImg lastImg"/>
        <img src="../../assets/img/about/zizhi/33.png" alt="" class="RowImg lastImg"/>
        <img src="../../assets/img/about/zizhi/44.png" alt="" class="RowImg lastImg"/>
      </div>
      <div class="certificateCol">
        <img
          v-lazy="item.src"
          alt=""
          v-for="(item, index) in certificateImgArr.slice(0,12)"
          :key="index"
          class="wow animate__zoomIn"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import banner1 from "../../assets/img/about/banner1.png";
import banner2 from "../../assets/img/about/banner2.png";
import banner3 from "../../assets/img/about/banner3.png";
import Map from "../../components/aboutMap/map.vue";
export default {
  props: {},
  data() {
    return {
      banner1,
      banner2,
      banner3,
      swiperOption: {
        loop: false,
        autoplay: false,
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      certificateImgArr: [
        // { src: require("../../assets/img/about/zizhi/55.png") },
        // { src: require("../../assets/img/about/zizhi/22.jpg") },
        // { src: require("../../assets/img/about/zizhi/33.png") },
        // { src: require("../../assets/img/about/zizhi/44.png") },
        { src: require("../../assets/img/about/zizhi/9.png") },
        { src: require("../../assets/img/about/zizhi/10.png") },
        { src: require("../../assets/img/about/zizhi/11.png") },
        { src: require("../../assets/img/about/zizhi/12.png") },
        { src: require("../../assets/img/about/zizhi/5.png") },
        { src: require("../../assets/img/about/zizhi/6.png") },
        { src: require("../../assets/img/about/zizhi/7.png") },
        { src: require("../../assets/img/about/zizhi/8.png") },
      ],
      patener:[
          { src: require("../../assets/img/about/zhouheiya.png") },
          { src: require("../../assets/img/about/dekeshi.png") },
          { src: require("../../assets/img/about/yonghedawang.png") },
          { src: require("../../assets/img/about/DQ.png") },
          { src: require("../../assets/img/about/quanjai.png") },
          { src: require("../../assets/img/about/maidanglao.png") },
          { src: require("../../assets/img/about/laoniangjiu.png") },
          { src: require("../../assets/img/about/xingbake.png") },
          { src: require("../../assets/img/about/kendeji.png") },
          { src: require("../../assets/img/about/huiwei.png") },
          { src: require("../../assets/img/about/shijihualian.png") },
          { src: require("../../assets/img/about/jixianghundun .png") },
      ]
    };
  },
  computed: {},
  created() {},
  mounted() {
    new WOW({ live: false }).init();
  },
  watch: {},
  methods: {
    gojiashi() {
      window.open("http://jiashizn.com/", "_blank");
    },
  },
  components: {
    swiper,
    swiperSlide,
    Map,
  },
};
</script>

<style scoped lang="scss">
#about {
  .firstPart {
    .banner {
      .el-image {
        width: 100%;
        height: 80rem;
        object-fit: cover;
      }
      .swiper-slide {
        position: relative;
      }
      /deep/ .el-image__inner{
          object-fit: cover;
      }
      .slideTitle {
        background: #02ada4;
        border-radius: 5px;
        padding: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 12rem;
        height: 4rem;
        margin-bottom: 3rem;
      }
      .slideInfo {
        position: absolute;
        top: 40%;
        left: 15%;
        width: 25%;
        color: #fff;
        font-size: 1.6rem;
        font-weight: 500;
        line-height: 2.2rem;
      }
      .aboutTxt {
        text-align: justify;
        line-height: 2.2rem;
      }
    }
  }
  
  .secondPart {
    padding: 2% 14%;
    .elRow {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .aboutItem {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 3rem;
        box-shadow: 0px 5px 40px 0px rgba(197, 197, 197, 0.38);
        border-radius: 4px;
        cursor: pointer;
        margin-top: 3rem;
        &:hover {
          box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
          transform: translate(0, -5px);
          transition: all 0.3s;
        }

        img {
          width: 6rem;
          height: 6rem;
          border-radius: 50%;
        }
        .bg1 {
          background: linear-gradient(101deg, #accafd, #6c88f1);
        }
        .bg2 {
          background: linear-gradient(238deg, #48d3e4, #61d5cf);
        }
        .bg3 {
          background: linear-gradient(101deg, #e3b6cf, #a079e4);
        }
        .boxNameEN {
          font-weight: 500;
          color: #666666;
          line-height: 3rem;
          font-size: 1.4rem;
          margin-bottom: 1rem;
        }
        .boxName {
          font-size: 1.6rem;
          font-weight: 500;
          color: #333333;
          line-height: 2.4rem;
          margin-top: 3rem;
        }
        .boxDesc {
          font-size: 1.4rem;
          font-weight: 400;
          color: #999999;
          line-height: 2.2rem;
          height: 10rem;
          text-align: justify;
        }
      }
    }
  }
  .thirdPart,
  .fourthPart {
    padding: 5% 14%;
    .middleRow {
      display: flex;
      flex-wrap: wrap;
      img {
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: 0.5rem;
      }
    }
    .itemTech {
        width: 80%;
      .title2 {
        color: #333333;
        line-height: 5rem;
        font-size: 2.6rem;
        margin-bottom: 5rem;
      }
      .content {
        font-size: 1.4rem;
        font-weight: 400;
        color: #777777;
        line-height: 2.2rem;
        width: 90%;
        text-align: justify;
        text-justify: inter-ideograph; /*IE*/
      }
      .itemRow {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 2rem;
        img {
          width: 2rem;
          margin-right: 1rem;
        }
        .itemTxt {
          font-size: 1.4rem;
          font-weight: 400;
          color: #999999;
          line-height: 3rem;
        }
      }
    }
  }
  .fourthPart {
    .fourthImg {
      width: 78% !important;
      height: 90% !important;
    }
    .cateName {
      width: 10rem;
      height: 3rem;
      background: #02ada4;
      border-radius: 4px;
      text-align: center;
      line-height: 3rem;
      color: #ffffff;
      font-size: 1.6rem;
      margin: 4rem 0 3rem;
    }
    .cateDesc {
      color: #666666;
      font-size: 1.4rem;
      line-height: 2rem;
      text-align: justify;
    }
    .logoBox {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .logos {
        width: 25%;
        height: 8rem;
        margin: 3rem 3rem 3rem 0;
        cursor: pointer;
        background-position: center;
        background-size: 80% 80%;
        background-repeat: no-repeat;
        &:hover {
          box-shadow: 0px 12px 38px 0px rgba(49, 127, 167, 0.09);
        }
      }
    }
  }
  .lastPart {
    padding: 5% 14%;
    background: #f6f8fa;
    .topPart {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-bottom: 3rem;
      .title {
        font-size: 2.6rem;
        color: #333333;
      }
    }
    
    .certificateRow,
    .certificateCol {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .certificateRow {
      justify-content: space-between;
      .RowImg,.yyzz {
        width: 16.5%;
        object-fit: fill;
        margin: 1rem 1rem 1rem 0;
        border-radius: 4px;
        &:hover {
          box-shadow: 0px 1rem 3rem 0px rgba(0, 0, 0, 0.4);
          transform: translate(0, -5px);
          transition: all 0.3s;
          transform: scale(1.1);
        }
      }
      .lastImg{
          width: 9%;
      }
    }
    .certificateCol {
      img {
        width: 9%;
        object-fit: fill;
        margin: 2rem 1rem 1rem 0;
        &:hover {
          box-shadow: 0px 1rem 3rem 0px rgba(0, 0, 0, 0.4);
          transform: translate(0, -5px);
          transition: all 0.3s;
          transform: scale(1.1);
        }
      }
    }
    
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: 6rem;
    height: 6rem;
    border-radius: 50%;
    background-size: 4rem 4rem;
    background-color: rgba(255, 255, 255, 0.3);
  }
  .swiper-button-prev {
    background-image: url("../../assets/img/about/left.png");
    left: 5%;
  }
  .swiper-button-next {
    right: 5%;
    background-image: url("../../assets/img/about/right.png");
  }
  
}
@import '../../assets/responsive/about.scss'
</style>
